import React from "react"
import {useAccessToken} from "../../../../services/auth"
import useAsyncResultIdle from "../../../../hooks/useAsyncResultIdle"

import {Application, resubmitOfficersBusinessApplication} from "../../../../resources/application"
import ConfirmationModalContent from "../ConfirmationModalContent"
import {ReevaluatedOfficerApplicationData} from "../../Forms/ReevaluateOfficerForm/ReevaluateOfficerForm"

export default function ReevaluateOfficerConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	application: Application
	officerId: string
	enableReevaluateApplication: boolean
	reevaluatedData: ReevaluatedOfficerApplicationData
}) {
	const {close, onSuccess, application, officerId, enableReevaluateApplication, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateOfficerRequest, setUpdateOfficerRequest] = useAsyncResultIdle(resubmitOfficersBusinessApplication)

	const handleSubmit = (reason: string) => {
		const data = {
			dateOfBirth: reevaluatedData.dateOfBirth,
			ssn: reevaluatedData.ssn,
			title: reevaluatedData.title,
			email: reevaluatedData.email,
			phone: reevaluatedData.phone,
			address: reevaluatedData.address,
			passport: reevaluatedData.passport,
			fullName: reevaluatedData.fullName,
			nationality: reevaluatedData.nationality,
			reasonText: reason,
			matriculaConsular: reevaluatedData.matriculaConsular,
			occupation: reevaluatedData.occupation,
			sourceOfIncome: reevaluatedData.sourceOfIncome,
			annualIncome: reevaluatedData.annualIncome,
		}

		setUpdateOfficerRequest(accessToken, application, officerId, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateOfficerRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={enableReevaluateApplication}
		/>
	)
}
